import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { adminPaymentReportMonthly } from "../../api";
import ReportTablePage from "../../components/admin/ReportTablePage";

function monthStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export default function PaymentReportMonthly() {
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState("perumahan");
  const [dateValue, setDateValue] = useState(monthStr());
  const [search, setSearch] = useState("");
  const [summary, setSummary] = useState({});
  const [kawasanSummary, setKawasanSummary] = useState([]);
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      setLoading(true);
      const res = await adminPaymentReportMonthly({ template, month: dateValue });
      setSummary(res.summary || {});
      setKawasanSummary(res.kawasan_summary || []);
      setItems(res.items || []);
    } catch (e) {
      await Swal.fire({ icon: "error", title: "Gagal", text: e?.response?.data?.error || "Gagal load laporan bayaran bulanan." });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [template, dateValue]);

  return (
    <ReportTablePage
      title="Laporan Bayaran Bulanan"
      subtitle="Rekod bayaran ikut bulan."
      loading={loading}
      template={template}
      setTemplate={setTemplate}
      dateMode="month"
      dateValue={dateValue}
      setDateValue={setDateValue}
      search={search}
      setSearch={setSearch}
      summary={summary}
      kawasanSummary={kawasanSummary}
      items={items}
      onRefresh={load}
      itemColumns={[
        { key: "no_akaun", label: "No Akaun" },
        { key: "nombor_unit", label: "Unit" },
        { key: "kawasan", label: "Kawasan" },
        { key: "paid_at", label: "Tarikh Bayar", render: (v) => (v ? new Date(v).toLocaleString() : "-") },
        { key: "amount", label: "Jumlah (RM)" },
        { key: "receipt_no", label: "Receipt" },
      ]}
    />
  );
}